export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'ENTITY-LOCATION': {
    ADD_LOCATION_TITLE: 'Añadir nueva sucursal',
    TITLE: 'Gestión de sucursales',
    TABLE: {
      TITLE: 'Listado de sucursales',
      FILTERS: {
        SEARCH: 'Buscar',
        SEARCH_PLACEHOLDER: 'Buscar por nombre, ciudad o dirección',
      },
      HEADER: {
        NAME: 'Nombre',
        ADDRESS: 'Dirección',
        CREATED_AT: 'Fecha',
        CREATED_AT_TOOLTIP: 'Fecha en que se creó la sucursal',
        CREATED_BY: 'Creada por',
        CITY: 'Ciudad',
        STATE: 'Provincia / Estado',
        COUNTRY: 'País',
        ACTIONS: 'Acciones',
      },
      ACTIONS: {
        DELETE: 'Eliminar sucursal',
        EDIT: 'Editar sucursal',
      },
      NO_DATA: 'No hay sucursales registradas',
    },
    DELETE: {
      CONFIRM_DELETE: {
        HEADER: '¿Eliminar esta sucursal?',
        MESSAGE: '¿Estás segur@ que deseas eliminar esta sucursal?<br>⚠️ Esta acción es <strong>permanente e irreversible.</strong><br>Se eliminarán todas las ofertas de esta sucursal y sus datos asociados.',
        CHECKBOX_LABEL: 'Confirmo que entiendo que no se puede deshacer.',
        ACCEPT: 'Eliminar',
        REJECT: 'Cancelar',
      },
      CONFIRM_DELETE_FINAL: {
        HEADER: '¿Estás completamente segur@?',
        MESSAGE: '🔴 Una vez eliminada, <strong>no hay vuelta atrás.</strong><br>Perderás todas las ofertas y datos de esta sucursal para siempre.',
        ACCEPT: 'Sí, eliminar definitivamente',
        REJECT: 'Cancelar',
      },
      SUCCESS_DELETE: {
        HEADER: 'Sucursal eliminada',
        MESSAGE: 'La sucursal ha sido eliminada con éxito.',
      },
    },
    FORM: {
      TITLE_CREATE: 'Añadir sucursal',
      TITLE_EDIT: 'Editar sucursal',
      FIELDS: {
        NAME: {
          LABEL: 'Nombre de la sucursal',
          PLACEHOLDER: 'Escribe el nombre de la sucursal...',
        },
        ADDRESS: {
          LABEL: 'Dirección',
          PLACEHOLDER: 'Escribe la dirección...',
          HINT: 'Escribe una dirección y selecciona una de las opciones sugeridas.',
        },
        CITY: { LABEL: 'Ciudad', PLACEHOLDER: 'Escribe la ciudad...' },
        STATE: {
          LABEL: 'Provincia / Estado',
          NOT_DETECTED_ERROR: 'Selecciona una dirección más precisa para que este campo se autocomplete.',
        },
        COUNTRY: { LABEL: 'País' },
        AUTOCOMPLETE_PLACEHOLDER: 'Campo autocompletado',
        CHANGE_IN_ADDRESS_TOOLTIP: 'Este campo se actualiza automáticamente al modificar la «Dirección».',
      },
      BUTTONS: {
        SAVE: 'Guardar',
        CANCEL: 'Cancelar',
        DELETE: 'Eliminar',
      },
      MESSAGES: {
        CREATED: 'Sucursal creada con éxito.',
        UPDATED: 'Sucursal actualizada con éxito.',
      },
    },
    ERRORS: {
      NOT_FOUND: 'Sucursal no encontrada',
      NOT_AUTHORIZED: 'No autorizado para realizar esta acción',
      UNKNOWN_ERROR: 'Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo.',
    },
  },
} as const;

